'use client';

import { useEffect, useRef } from 'react';

import { clsx } from 'clsx';

import { useAppDispatch, useAppSelector } from '@shared/hooks/redux';
import { Container } from '@shared/ui/Container';
import { getViewPort } from '@shared/ui/ScreenSizeTracking';
import { toggleSearch } from '@widgets/Header';
import { MenuBlock } from '@widgets/Header/ui/Bot/MenuBlock/MenuBlock';

import { Search } from './Search/Search';
import { UserNavigation } from './UserNavigation/UserNavigation';
import cls from './Bot.module.scss';

export const Bot = () => {
  const lastScrollTop = useRef<number>(0);

  const dispatch = useAppDispatch();

  const hideSearch = useAppSelector((state) => state.header.hideSearch);
  const viewPort = useAppSelector(getViewPort);

  useEffect(() => {
    if (viewPort !== 'mobile') return;

    const scrollHandler = () => {
      const scrollDistance = window.scrollY;

      if (scrollDistance > lastScrollTop.current) {
        if (scrollDistance > 100) {
          dispatch(toggleSearch(true));
        }
      } else {
        dispatch(toggleSearch(false));
      }

      lastScrollTop.current = scrollDistance;
    };

    window.addEventListener('scroll', scrollHandler);

    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, [dispatch, viewPort]);

  return (
    <>
      <div
        data-hide={hideSearch ? 'Y' : 'N'}
        data-testid="header-bot"
        className={clsx(cls.wrap, { [cls.hide]: hideSearch })}
      >
        <Container className={cls.container}>
          <MenuBlock />
          <Search />
          <UserNavigation />
        </Container>
      </div>
    </>
  );
};
